module.exports = __webpack_public_path__ + "img/color-e-2@2x.6a4e94a.webp";